import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { state } from "./state";

import menuItems from "./menu-items/index";
import menuItemsFilter from "./menu-items-filter/index";

export const ALCOHOL_LIMIT_MESSAGE_PER_ORDER = "Maximum allowed alcohol quantity for this order is reached";
export const ALCOHOL_RESTRICTION_MESSAGE = "You must be 21+ to purchase alcohol. Please be prepared to present your ID.";
export const MODIFIERS_REQUIRED_MESSAGE =
  "This item requires at least one modifier to be selected. Please select one option before attempting to proceed.";
export const CUSTOM_AVAILABILITY_FIELD = "iwVendorStatus";

export default {
  namespaced: true,
  modules: {
    menuItems,
    menuItemsFilter
  },
  state,
  getters,
  actions,
  mutations
};
